<div class="photo-grid">
  <ng-container *ngIf="(columns$ | async) as columns; else loading">
    <mat-card class="dashboard-card photo-card" *ngFor="let item of (rows$ | async); trackBy: identify"
      (click)="openDialog(item)" tabindex="0">
      <img lazyload class="photo-img" mat-card-image [src]="item[imageColumn]" appImageError errorImage="assets/shiva/no-img.webp">
      <mat-card-header>
        <mat-card-title *ngIf="title">
          <h5>{{ item[title] || ''}}</h5>
        </mat-card-title>
        <mat-card-subtitle *ngIf="subtitle || email">
          <h5 class="tertiary">{{ item[subtitle] || '' }}</h5>
          <h5 *ngIf="email">{{ item[email] || '' }}</h5>
        </mat-card-subtitle>
      </mat-card-header>
    </mat-card>
  </ng-container>

  <ng-template #loading>
    <p>Cargando datos...</p>
  </ng-template>
</div>
<ng-template #loading>
  <p>Cargando datos...</p>
</ng-template>